<app-header />
<main>
  <router-outlet />
</main>
<app-footer />
